const getDefaultState = () => {
  return {
    isCallingApi: false
  }
};
const state = getDefaultState();

const mutations = {
  SET_IS_CALLING_API (state, payload) {
    state.isCallingApi = payload;
  }
};

const actions = {

};

export default {
  state, mutations, actions
};



// WEBPACK FOOTER //
// ./src/stores/modules/commonStore.js